"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractConfigSetImpl = void 0;
var ContextInjector_1 = __importDefault(require("./context/ContextInjector"));
var InterceptorChain_1 = __importDefault(require("./interceptor/InterceptorChain"));
var ConfigStoreInterceptorProxy_1 = __importDefault(require("./interceptor/ConfigStoreInterceptorProxy"));
var AbstractConfigSetImpl = /** @class */ (function () {
    function AbstractConfigSetImpl(configStore, interceptors, queryContextProvider, weblabContextProvider) {
        this.LISTING_IS_NOT_SUPPORTED = 'This feature is coming soon. '
            + 'More info: https://sim.amazon.com/issues/ConfigPlane-FR-17';
        var allInterceptor = [];
        if (queryContextProvider || weblabContextProvider) {
            allInterceptor.push(new ContextInjector_1.default(queryContextProvider, weblabContextProvider));
        }
        interceptors.forEach(function (interceptor) { return allInterceptor.push(interceptor); });
        var chain = InterceptorChain_1.default.create(allInterceptor);
        this.configStoreProxy = new ConfigStoreInterceptorProxy_1.default(configStore, chain);
    }
    return AbstractConfigSetImpl;
}());
exports.AbstractConfigSetImpl = AbstractConfigSetImpl;
exports.default = AbstractConfigSetImpl;
